import * as React from "react";
import { useSelector, useDispatch } from "react-redux";
import { useEffect, useRef, useState } from "react";
import queryString from "query-string";
import { useNavigate, useSearchParams } from "react-router-dom";
import { PATHS } from "../../../router/paths";

import Notes from './Notes/index';
import Files from './Files/index';
import Log from './Log/index';
import Diaries from './Diaries/index';
import Parties from './Parties/index';
import Icon from '../../../icons';
import CloseActivityComponent from '../../../components/CloseActivity';
import { IS_PARTIES_ENABLED, DETAIL_INFO, CharConstants, LeftPanelConstant, StringConstants, ActivityActions, MiddlePanelConstant, RightPanelConstant, ErrorCode, CHOOSE_AN_ACTIVITY_TEMPLATE } from '../../../containers/WorkkardDetail/constants';
import { useModules } from '../../../utils/modules';
import ChoseReason from '../../../components/ChoseReason';
import { SeturlHash, getCustomerLastName } from '../../../containers/WorkkardDetail/utils';
import { setActivityId } from '../../../containers/WorkkardDetail/actions/commonAction';
import AssociatedPartiesComponent from '../../Header/AssociatedParties';
import RightPopUpComponent from '../../../components/RightPopUpComponent';
import AddEditActivity from '../../CreationForms/AddEditActivity';
import CombinedView from '../CombinedView';
import {
  fetchMiddlePanelData,
  fetchMiddlePanelFilesData,
  fetchMiddlePanelNotesData,
  fetchMiddlePanelLogsData,
  changeActivityResolution,
  postActivityMenuActions,
  setPanelVisibility
} from "../../../containers/WorkkardDetail/actions/action";
import * as CommonUtil from '../../../common/util';
import { showDialogueBox, hideDialogueBox } from '../../../components/DialogueBox/actions';
import { showRightPopUpeBox, hideRightPopUpBox } from "../../../components/RightPopUpComponent/actions";
import ActivityDetail from '../../../components/ActivityDetail';
import ConfirmationTextBox from "../../../components/ConfirmationPrompt";
import RejectActivityReason from "../../../components/RejectActivityReason";
import { setPartyAssociation } from "../../Header/actions/action";
import { Urls } from '../../../common/urlRouting';
import Select from '../../../components/Select';
import { hideToast } from '../../SpockViewPage/actions/action';
import DiaryCreation from "../../CreationForms/DiaryCreation";
import { mobileAndTabletcheck } from "../../../common/util";
import { selectSessionContextOidc } from '@container/AdminPanel/features/users/usersSelectors';
import { useLegacyHistory } from "@/router/hooks";
import { getActivityActions } from "../../../common/menuHelper";
import { normalizePermissions } from "../../../common/normalizers/userPermission"
import { getDiariesListData } from "../../Diaries/actions";

const shortNameTab = ['n', 'f', 'd', 'l', 'p'];
// Positions in shortNameTab, which is also the activeTab index renderTabs switches on.
const TAB_INDEX = { notes: 0, files: 1, diaries: 2, logs: 3, parties: 4 };

const MiddlePanelContainer = (props) => {
    const  navigate = useNavigate()
    const [searchParams] = useSearchParams()
    const dispatch = useDispatch();
    const { isModuleEnabled } = useModules();
    const { history } = useLegacyHistory();
    const userList = useSelector(state => state.userList);
    const activityDetail = useSelector(state => state.workkardDetail.activityDetail);
    const workkard = useSelector(state => state.workkardDetail.workkardDetail);
    const middlePanel = useSelector(state => state.workkardDetail.middlePanel);
    const toggleView = useSelector(state => state.workkardDetail.panelVisibility.toggleView);
    const isLeftPanelVisible = useSelector(state => state.workkardDetail.panelVisibility.isLeftVisible);
    const isNoteVisible = useSelector(state => state.workkardDetail.panelVisibility.isNoteVisible);
    const activityListing = useSelector(state => state.workkardDetail.activityListing);
    const workkardId = useSelector(state => state.workkardDetail.workkardDetail?.Id);
    const currentActivityId = useSelector(state => state.workkardDetail.activityDetail?.activityId);
    const notesType = useSelector(state => state.workkardDetail.middlePanel.notes.type);
    const logsType = useSelector(state => state.workkardDetail.middlePanel.logs.type);
    const detailActivityActions = useSelector(state => state.workkardDetail.activityDetail?.activityActions);
    const activityOwnerOrgId = useSelector(state => state.workkardDetail.activityDetail?.ownerOrgId);
    const isToast = useSelector(state => state.toast.show);
    const showFilter = props.showFilter;
    const sessionContext = useSelector(selectSessionContextOidc);
    const userView = sessionContext?.userView;
    const userPermission = userView?.permissions;
    const { listingData } = useSelector(state => state.diaries.listing);
    const isNewCreateAct = useRef(document.getElementById('isNewLayoutCreateActivity') ? document.getElementById('isNewLayoutCreateActivity').value : null);
    const menuActionRef = useRef(null);
    const activityDetailRef = useRef(null);

    const [canChangeProgress, setCanChangeProgress] = useState(false);
    const [canAddNote, setCanAddNote] = useState(false);
    const [clickedActivityId, setClickedActivityId] = useState("");
    const [showDetailTooltip, setShowDetailTooltip] = useState(false);
    const [showDetailPopup, setShowDetailPopup] = useState(false);
    const [showActivityListDropDown, setShowActivityListDropDown] = useState(false);
    const [canEditActivity, setCanEditActivity] = useState(false);
    const [showMenuAction, setShowMenuAction] = useState(false);
    const [showMenuNoteAndDiary, setShowMenuNoteAndDiary] = useState(false);
    const [activityActions, setActivityActions] = useState(activityDetail?.activityActions || []);

    const calculateDynamicPosition = () => {
        let filterBlock = document.querySelector(".secondLayout .filterBlock");

        if (filterBlock) {
            let filterRect = filterBlock.getBoundingClientRect()
            let tableHead = document.querySelector(".secondLayout").querySelector(".tableHead");
            let topPosition = (filterRect.top + filterRect.height - 65) + (tableHead ? tableHead.clientHeight + 8 : 0);
            let listingDiv = document.querySelector(".secondLayout").querySelector(".scrollArea");
            let noDataDiv = document.querySelector(".secondLayout .noDataFound")
            if (listingDiv) listingDiv.style.top = topPosition + "px";
            if (noDataDiv) noDataDiv.style.top = topPosition + "px";
        }
    }

    // function to  handle the request when click on add note button and hide and show  the panels
    const onCreateNoteClick = () => {
        if (CommonUtil.showWriteOffNotification() == "false") {
            dispatch(hideToast());
            const panelVisibilityData = {
                templateType: CharConstants.Activity,
                isLeftVisible: false,
                isRightVisible: false,
                isNoteVisible: true,
                showWkInMobileView: true
            };
            dispatch(setPanelVisibility(panelVisibilityData));
        }
    };

    // change resolution function
    const onProgressChange = (value) => {
        if (value > 0) {
            const payload = {
                "ActivityId": activityDetail.activityId,
                "actionType": MiddlePanelConstant.InProgressText,
                "ddlActivityProgress": value,
                "cId": workkard.Id,
                "refreshActivityDetail": true,
                activityTemplateType: activityDetail.activityTemplateType
            };
            dispatch(changeActivityResolution(payload));
        }
    };

    //  function that update redux  state with which tab is  active now
    const onTabClick = (tabNumber) => {
        if (isToast) {
            dispatch(hideToast());
        }
        dispatch(fetchMiddlePanelData({ activeTab: tabNumber }));
    };

    // close the  dialog of activity detail dialog
    const closeDialogBox = () => {
        setShowDetailPopup(false);
        setShowDetailTooltip(false);
        dispatch(showDialogueBox({
            flag: false,
            dialogueBoxComponent: null,
        }));
    };

    // show  the activity detail dialog
    const showActivityDetails = () => {
        dispatch(showDialogueBox({
            flag: true,
            component: <ActivityDetail title={DETAIL_INFO} onClose={closeDialogBox} onFullScreen={null} data={activityDetail} showDetailTooltip={false} canEdit={canEditActivity} />,
            overlayClassName: "modal animated faster fadeIn",
            contentClassName: "modalContent fullView animated faster fadeInUpx2 medium modalAlignFromTop",
            shouldCloseOnOverlayClick: false
        }));
    };

    // function to  get  activity menu list
    const getActivityMenuList = () => {
        if (activityDetail && activityActions) {
            let discardItemList = [StringConstants.InProgress, StringConstants.ChangeWorkkardSponsor, StringConstants.ReassignActivity, StringConstants.ChangeActivityOwner, StringConstants.AddNote];
            let menuActions = CommonUtil.getMenuActions(ActivityActions, activityActions);
            return (
                menuActions.map((item, key) => {
                    if (!discardItemList.includes(item.value)) {
                        if (item.value?.toLowerCase() === StringConstants.CloneActivity.toLowerCase() && !isModuleEnabled("activities.clone_activity")) {
                            return null;
                        }
                        return (
                            <span onClick={(e) => { return onClickActivityAction(e, item.type) }} key={key}><a href="javascript:void(0);">  {item.value}</a></span>
                        );
                    } else return null;
                })
            );
        } else {
            return null;
        }
    };

    const closeConfirmationBox = () => {
        dispatch(hideDialogueBox());
    };

    const confirmActionOnYes = (type, reasonId, reason="", subReason = "") => {
        closeConfirmationBox();
        var datajson = {
            "ActivityId": activityDetail.activityId,
            "actionType": type,
            "cId": workkard.Id
        };
        if (type === MiddlePanelConstant.ReOpenText && reasonId) {
            datajson["wrrId"] = reasonId;
        }
        if (type === MiddlePanelConstant.ReOpenText && reason) {
            datajson["wrr"] = reason;
            datajson["wrSubReason"] = subReason;
        }
        if (type === MiddlePanelConstant.RejectText && reason) {
            datajson["rejectReason"] = reason;
        }
        dispatch(postActivityMenuActions(datajson));
    };

    const showRejectReasonBox = () => {
        const component = <RejectActivityReason
            message={MiddlePanelConstant.RejectActivityConfirmationText}
            confirmationText={MiddlePanelConstant.RejectButtomText}
            onConfirmClick={(reason) => confirmActionOnYes(MiddlePanelConstant.RejectText, null, reason)}
            onCancelClick={closeConfirmationBox}
        />;
        return dispatch(showDialogueBox({
            flag: true,
            component,
            overlayClassName: "modal",
            contentClassName: "modalContent small animated faster fadeInUpx2 confirmModal",
            shouldCloseOnOverlayClick: true
        }));
    };

    const confirmActionOnClone = (reason, subReasonId) => {
        window.location = Urls.CLONE_ACTIVITY + "?actId=" + activityDetail.activityId + "&workkardId=" + workkard.Id + "&wrrId=" + reason + "&wrSubReasonId=" + subReasonId + "&ret=getclmdetail?cId=" + workkard.Id;
    };

    const showGenericDialogueBox = (messageText, confirmButtomType, comfirmButtomText) => {
        let component = <ConfirmationTextBox
            class={"modalBody"}
            message={messageText}
            onConfirmClick={() => confirmActionOnYes(confirmButtomType)}
            onCancelClick={closeConfirmationBox}
            confirmationText={comfirmButtomText}
            footerClass={"modalFooter"}
            cancelText={"Cancel"}
        />;
        let contentClassName = "modalContent small animated faster fadeInUpx2 confirmModal";
        if (MiddlePanelConstant.ReopenActivityConfirmationText === messageText) {
            if (workkard.WorkkardStatus?.toUpperCase() === 'CLOSE' && userPermission?.can_reopen_workkard && (workkard.OrganizationId === userView.orgId)) {
                component = <ChoseReason title={StringConstants.ReopenActivity} isReopenActivity={true} onConfirmClick={(data) => { confirmActionOnYes(confirmButtomType, data.reasonId, data.reason, data.subReason) }} onClose={closeConfirmationBox} />;
                contentClassName = "modalContent medium animated faster fadeInUpx2 reopenActivityModal";
            } else if (workkard.WorkkardStatus?.toUpperCase() === 'CLOSE' && !userPermission?.can_reopen_workkard) {
                component = <ConfirmationTextBox
                    header={"Cannot Reopen Activity!"}
                    class={"modalBody"}
                    message={MiddlePanelConstant.CanReopenWorkkardPermissionDenied}
                    onConfirmClick={closeConfirmationBox}
                    confirmationText={"Close"}
                    footerClass={"modalFooter"}
                />;
            }
        }
        return dispatch(showDialogueBox({
            flag: true,
            component: component,
            overlayClassName: "modal",
            contentClassName: contentClassName,
            shouldCloseOnOverlayClick: true
        }));
    };

    const closeActivityComfirm = () => {
        closeConfirmationBox();
        dispatch(postActivityMenuActions({
            ActivityId: activityDetail.activityId,
            actionType: MiddlePanelConstant.CloseText,
            cId: workkard.Id
        }));
    }
    const onSuccess = (response, type) => {
        let component, contentClassName;
        if (response.status == ErrorCode.Success) {
            // Todo : ad cache permission here for activity close 
            // if(isModuleEnabled('close_activity')){
            //     component = <CloseActivityComponent activityId={activityDetail.activityId} workkardId={activityDetail.workkardId} type={type} />;
            //     contentClassName = `${mobileAndTabletcheck() ? "modalContent animated faster fadeInUpx2" : "modalContent animated faster fadeInUpx2 fullView large modalAlignFromTop"}`;
            // }else{
                component =  <ConfirmationTextBox
                                class={"modalBody"}
                                message={"Are you sure you want to close this activity"}
                                onConfirmClick={closeActivityComfirm}
                                onCancelClick={ () => { dispatch(hideDialogueBox()); }}
                                confirmationText={"Continue"}
                                cancelText={"Cancel"}
                                footerClass={"modalFooter"}
                            />
                contentClassName = "modalContent small animated faster fadeInUpx2 ";
            // }
            
        } else if (response.status == ErrorCode.ActionDenied) {
            component = <ConfirmationTextBox
                header={"Cannot Close Activity!"}
                class={"modalBody"}
                message={response.error}
                onConfirmClick={closeConfirmationBox}
                confirmationText={"Close"}
                footerClass={"modalFooter"} />;
            contentClassName = "modalContent small animated faster fadeInUpx2 ";
        }
        return dispatch(showDialogueBox({
            flag: true,
            component: component,
            overlayClassName: "modal animated faster fadeIn",
            contentClassName: contentClassName,
        }));
    };

    const onClickActivityAction = (e, type) => {
        switch (e.target.innerText.trim()) {
            case StringConstants.CloseActivity: {
                const canCloseActivity = type === 'closeMidTerm' ? userPermission?.can_close_activity_during_mid_term : userPermission?.can_close_activity;
                const response = canCloseActivity
                    ? { status: ErrorCode.Success }
                    : { status: ErrorCode.ActionDenied, error: MiddlePanelConstant.UNAUTHORIZED_ACTION };
                return onSuccess(response, type);
            }
            case StringConstants.Reopen: {
                return showGenericDialogueBox(MiddlePanelConstant.ReopenActivityConfirmationText, MiddlePanelConstant.ReOpenText, MiddlePanelConstant.ReopenButtomText);
            }
            case StringConstants.Complete: {
                return showGenericDialogueBox(MiddlePanelConstant.CompleteActivityConfirmationText, MiddlePanelConstant.CompleteText, MiddlePanelConstant.CompleteButtomText);
            }
            case StringConstants.Accept:
                return showGenericDialogueBox(MiddlePanelConstant.AcceptActivityConfirmationText, MiddlePanelConstant.AcceptText, MiddlePanelConstant.AcceptButtomText);
            case StringConstants.Reject:
                return showRejectReasonBox();
            case StringConstants.Edit:
                const workkardId = activityDetail.workkardId || searchParams.get('cId')
                const actId = props?.activityDetail?.ActivityId || searchParams.get('actId')

                return navigate(
                    PATHS.ACTIVITY_EDIT.replace(':workkardId', workkardId).replace(':actId', actId),
                    { state: { returnUrl: `${window.location.pathname}${window.location.search}${window.location.hash}` } }
                )
            case StringConstants.Clone: {
                if (!userPermission?.can_reopen_workkard) {
                    let component = <ConfirmationTextBox
                        header={"Cannot Clone Activity!"}
                        class={"modalBody"}
                        message={MiddlePanelConstant.CloneWorkkardPermissionDenied}
                        onConfirmClick={closeConfirmationBox}
                        confirmationText={"Close"}
                        footerClass={"modalFooter"}
                    />;
                    let contentClassName = "modalContent small animated faster fadeInUpx2";
                    return dispatch(showDialogueBox({
                        flag: true,
                        component: component,
                        overlayClassName: "modal",
                        contentClassName: contentClassName,
                        shouldCloseOnOverlayClick: true
                    }));
                } else if (workkard.WorkkardStatus?.toUpperCase() === 'CLOSE' && (workkard.OrganizationId === userView.orgId)) {
                    return dispatch(showDialogueBox({
                        flag: true,
                        component: <ChoseReason isCloneActivity={true} actId={activityDetail.activityId} wkid={workkard.Id} title={StringConstants.CloneActivity} history={history} onConfirmClick={(data) => { confirmActionOnClone(data.reasonId, data.subReasonId) }} onClose={closeDialogBox} />,
                        overlayClassName: "modal",
                        contentClassName: "modalContent medium animated faster fadeInUpx2 reopenActivityModal",
                        shouldCloseOnOverlayClick: true,
                    }));
                } else {
                    return dispatch(showDialogueBox({
                        flag: true,
                        component: <AddEditActivity onClose={closeDialogBox} isClone={true} isEdit={false} workkardId={props.workkard.Id} referrer="" history={props.history} actId={props.activityDetail.ActivityId} />,
                        overlayClassName: "modal animated faster fadeIn",
                        contentClassName: "modalContent globalSearchModalContent modalFixed animated faster fadeInUpx2 medium",
                        shouldCloseOnOverlayClick: true,
                    }));
                }
            }
            default:
                return null;
        }
    };

    // hide show menu  actions
    const onClickMenuActionButton = () => {
        setShowMenuAction(prev => !prev);
    };

    const onClickMenushowMenuNoteAndDiaryButton = () => {
        setShowMenuNoteAndDiary(prev => !prev);
    };

    const onClickMenuOutside = (e) => {
        if (menuActionRef.current && !menuActionRef.current.contains(e.target)) {
            setShowMenuAction(false);
            setShowMenuNoteAndDiary(false);
        }
        if (activityDetailRef.current && !activityDetailRef.current.contains(e.target)) {
            setShowActivityListDropDown(false);
            setShowMenuNoteAndDiary(false);
        }
    };

    const closeRightPopUp = () => {
        dispatch(hideRightPopUpBox());
    };

    const onAddPartyClick = () => {
        dispatch(setPartyAssociation("activity"));
        dispatch(showRightPopUpeBox({
            flag: true,
            component: <AssociatedPartiesComponent onClose={closeRightPopUp} associateWith="activity" />,
            overlayClassName: "modal animated faster fadeIn",
            contentClassName: "modalContent animated faster fadeInUpx2 medium",
            shouldCloseOnOverlayClick: true
        }));
        setShowMenuAction(false);
        setShowMenuNoteAndDiary(false);
    };

    const resolveActiveTab = () => middlePanel && middlePanel.activeTab
        || (typeof middlePanel.activeTab === 'undefined' && history.location.hash.length !== 0 &&
            history.location.hash.length < 3 && shortNameTab.indexOf(history.location.hash.charAt(2))) || 0;

    // render the  tab on the  basis of redux state activieTab
    const renderTabs = () => {
        const activeTab = resolveActiveTab();
        switch (activeTab) {
            case 0: {
                return (
                    <Notes history={history} />
                );
            }
            case 1: {
                return isModuleEnabled(activityDetail.activityId ? "activities.files" : "workkards.files") && (
                    <Files history={history} />
                );
            }
            case 2: {
                return isModuleEnabled("diaries") && (
                    <Diaries history={history} />
                );
            }
            case 3: {
                return isModuleEnabled(activityDetail.activityId ? "activities.logs" : "workkards.logs") && (
                    <Log history={history} />
                );
            }
            case 4: {
                return (
                    <Parties history={history} />
                );
            }
            default: {
                return (
                    <Notes history={history} />
                );
            }
        }
    };

    const renderView = (view) => {
        switch (view) {
            case RightPanelConstant.NormalView:
                return renderWorkkardDetailView();
            case RightPanelConstant.CombinedViewText:
                return isModuleEnabled("workkards.combined_view") && renderCombinedView();
            default:
                return null;
        }
    };

    // keep the dropdown's selection in step with redux (the left panel and the url both
    // write currentActivity), instead of setting state during render
    useEffect(() => {
        if (clickedActivityId !== activityListing.currentActivity) {
            setClickedActivityId(activityListing.currentActivity);
        }
    }, [activityListing.currentActivity]);

    const handleActivityChange = (data) => {
        let newClickedActivityId = parseInt(data);
        setClickedActivityId(newClickedActivityId);
        setShowActivityListDropDown(false);
        dispatch(setActivityId({ id: newClickedActivityId }));
        SeturlHash(false, newClickedActivityId, workkard.Id, history);
    };

    const renderActivityListing = (Props) => {
        if (Props.activities && Props.activities.length > 0) {
            return (
                <div>
                    <span data-test={`activityHeading ${Props.total}`}>
                       {CommonUtil.isMobile() && 
                        <a className="addActivitiesToMobile">
                        {LeftPanelConstant.ActivitiesText} ({ Props.total || 0 }) 
                        {isModuleEnabled("workkards.add_activity") && isModuleEnabled("activities.create_activity") && <button className="btn btnAdd buttonGradient addIcon ml" onClick={onCreateActivityClick} title="Add activity">
                            <Icon name="add" className="icon" /></button>}
                        </a>
                        }
                    </span>
                    {
                        Props.activities.map((item, index) => {
                            return (
                                <a key={index + '_' + item['activityName']} className={clickedActivityId==item['activityId']?"alignMiddle rowSpaceBetween active":"alignMiddle rowSpaceBetween"} >
                                <span className="dummyClassNameForUnitTest pointer" onClick={() => handleActivityChange(item['activityId'])}>
                                    {item['activityName']}
                                </span>
                               {clickedActivityId==item['activityId']&& <span className="badges profileChecked sortChecked green"></span>}
                                </a>
                            );
                        })
                    }
                </div>
            );
        } else {
            return (
                <select>
                    <option value={LeftPanelConstant.NoActivityFoundText}>
                        {LeftPanelConstant.NoActivityFoundText}
                    </option>
                </select>
            );
        }
    };

    const showRightPanelPopUpsOnMobileDevices = (data) => {
        props.handleRightPanelPopUpsOnMobileDevices(data);
    };

    const closeDiaryCreationForm = () => {
        dispatch(showDialogueBox({
            flag: false,
            dialogueBoxComponent: null,
        }));
    };

    const onAddDiaryClick = () => {
        dispatch(showDialogueBox({
            flag: true,
            component: <DiaryCreation
                actId={activityDetail.activityId || 0}
                wkId={workkard.Id}
                wkNumber={workkard.WorkkardNumber}
                customerLastName={getCustomerLastName(workkard.CustomFields)}
                type={StringConstants.activity}
                onClose={closeDiaryCreationForm}
                referrer="tdo"
            />,
            overlayClassName: "modal fullViewMain",
            contentClassName: "modalContent fullView animated faster fadeInUpx2 medium",
            shouldCloseOnOverlayClick: false
        }));
    };

    const onCreateActivityClick = () => {
        const historySnapshot = Object.assign({}, history);
        dispatch(showDialogueBox({
            flag: true,
            component: <ChoseReason history={historySnapshot} isCreateActivity={true} wkid={workkard.Id} title={CHOOSE_AN_ACTIVITY_TEMPLATE} onClose={closeConfirmationBox} />,
            overlayClassName: "modal",
            contentClassName: "modalContent medium animated faster fadeInUpx2",
            shouldCloseOnOverlayClick: true,
        }));
    };

    useEffect(() => {
        document.addEventListener('mousedown', onClickMenuOutside);
        window.addEventListener('resize', calculateDynamicPosition);

        const urlHash = window.location.hash;
        let activeTab = 0;
        if (urlHash === "#parties") {
            activeTab = shortNameTab.indexOf("p");
        } else if (urlHash === "#files") {
            activeTab = shortNameTab.indexOf("f");
        } else if (urlHash.length > 0 && urlHash.length <= 3) {
            activeTab = shortNameTab.indexOf(urlHash.charAt(2));
        }

        dispatch(fetchMiddlePanelData({ activeTab: activeTab }));
        const QuerySearchValues = queryString.parse(window.location.search);
        if ((!urlHash.length) && (typeof QuerySearchValues.combined === 'undefined' || QuerySearchValues.combined && !JSON.parse(QuerySearchValues.combined.split('#')[0]))) {
            CommonUtil.redirectURL(history, { pathname: window.location.pathname, search: window.location.search, hash: 'an' });
        }

        return () => {
            document.removeEventListener('mousedown', onClickMenuOutside);
            window.removeEventListener('resize', calculateDynamicPosition);
        };
    }, []);

    useEffect(() => {
        if(workkard.Id && isModuleEnabled("diaries")) {
            dispatch(getDiariesListData({
                cId     : workkard.Id,
                status  : 'open',
                page_no : 1
            }));
        }
    }, [workkardId]);

    const activeTabRef = useRef(null);
    activeTabRef.current = resolveActiveTab();

    useEffect(() => {
        if (activeTabRef.current === TAB_INDEX.files) return;
        if (workkard.Id) {
            const baseFilterOption = middlePanel.files?.filter?.filterOption || [];
            dispatch(fetchMiddlePanelFilesData({
                type: 'All',
                cId: workkard.Id,
                actId: activityDetail?.activityId || 0,
                skip: 0,
                take: 100,
                sortBy: "1",
                largeView: false,
                isSelectAll: false,
                filterOption: JSON.stringify([...baseFilterOption, 'workkard', 'activity']),
            }));
        }
    }, [workkardId, currentActivityId]);

    useEffect(() => {
        if (activeTabRef.current === TAB_INDEX.notes && clickedActivityId == activityDetail?.activityId) return;
        if (workkard.Id) {
            const notesType = middlePanel.notes.type;
            const actId = activityDetail?.activityId || 0;
            if ((notesType === MiddlePanelConstant.ActivityType && actId > 0) || notesType === MiddlePanelConstant.WorkkardType) {
                dispatch(fetchMiddlePanelNotesData({
                    request: {
                        type: notesType,
                        cId: workkard.Id,
                        actId,
                        skip: 0,
                        take: 10,
                        sortBy: notesType === MiddlePanelConstant.ActivityType ? "0" : "1",
                        reviewFilter: middlePanel.notes.reviewFilter,
                    }
                }));
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [workkardId, currentActivityId, notesType]);

    useEffect(() => {
        if (activeTabRef.current === TAB_INDEX.logs) return;
        if (workkard.Id) {
            const logsType = middlePanel.logs.type;
            const actId = activityDetail?.activityId || 0;
            const fetchCondition = (logsType === MiddlePanelConstant.ActivityType && actId > 0) || logsType === MiddlePanelConstant.WorkkardType;
            if (fetchCondition) {
                const logsPayload = { type: logsType };
                if (logsType === MiddlePanelConstant.ActivityType) {
                    logsPayload.actId = actId;
                } else if (logsType === MiddlePanelConstant.WorkkardType) {
                    logsPayload.cId = workkard.Id;
                }
                dispatch(fetchMiddlePanelLogsData(logsPayload));
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [workkardId, currentActivityId, logsType]);

    useEffect(() => {
        if (activityDetail?.ownerOrgId > 0) {
            let actionArray = CommonUtil.getMenuActions(ActivityActions, activityDetail.activityActions);
            let canChangeInprogress = actionArray.filter(item => item.value.includes(StringConstants.InProgress));
            let canAddNoteArr = actionArray.filter(item => item.value.includes(StringConstants.AddNote));
            let canEditActivityArr = actionArray.filter(item => item.value.includes(StringConstants.Edit));
            setCanChangeProgress(canChangeInprogress.length > 0);
            setCanAddNote(canAddNoteArr.length > 0);
            setCanEditActivity(isModuleEnabled("activities.activity_edit") && canEditActivityArr.length > 0);
            setActivityActions(activityDetail.activityActions);
        }
    }, [currentActivityId, detailActivityActions, activityOwnerOrgId]);

    useEffect(() => {
        const timer = setTimeout(calculateDynamicPosition, 200);
        if (workkard.WorkkardNumber && document.title !== workkard.WorkkardNumber) {
            document.title = workkard.WorkkardNumber;
        }
        return () => clearTimeout(timer);
    }, [workkardId, currentActivityId, middlePanel.activeTab, toggleView, isLeftPanelVisible, workkard.WorkkardNumber]);

    const returnCount = (type) => {
        switch (type) {
            case 'notes': {
                if (middlePanel.notes && typeof middlePanel.notes.total !== 'undefined' && middlePanel.notes.total > -1) {
                    return middlePanel.notes.total;
                } else {
                    return activityDetail && activityDetail.activityNoteCount || 0;
                }
            }
            case 'files': {
                if (middlePanel.files && typeof middlePanel.files.total !== 'undefined' && middlePanel.files.total > -1) {
                    return middlePanel.files.total;
                } else {
                    return activityDetail && activityDetail.activityFileCount || 0;
                }
            }
            case 'logs': {
                if (middlePanel.logs && typeof middlePanel.logs.total !== 'undefined' && middlePanel.logs.total > -1) {
                    return middlePanel.logs.total;
                } else {
                    return activityDetail && activityDetail.activityLogCount || 0;
                }
            }
            case 'diaries': {
                if(listingData?.total ) {
                    return listingData?.total
                } else {
                    return 0;
                }
            }
            case 'parties': {
                if (middlePanel.parties && typeof middlePanel.parties.total !== 'undefined' && middlePanel.parties.total > -1) {
                    return middlePanel.parties.total;
                } else {
                    return activityDetail && activityDetail.activityPartyCount || 0;
                }
            }
        }
    };

    const renderCombinedView = () => {
        return <CombinedView />;
    };

    const renderWorkkardDetailView = () => {
        const { activeTab } = middlePanel;
        const inProgressOptions = [{ label: "Select", value: "0", disabled: true }].concat(MiddlePanelConstant.InProgressOption.map(data => ({ label: `${data}%`, value: data })));
        const isAddNoteVisible = !isNoteVisible;
        let isMobileDevice = CommonUtil.mobileAndTabletcheck();
        return (
            <div>
                <div className="forMobileOnly">
                    <ul>
                        <li onClick={() => showRightPanelPopUpsOnMobileDevices(RightPanelConstant.WorkkardDetailText)}><Icon name="WorkkardDetail" className="icon shift__top__1" /></li>
                        <li onClick={() => showRightPanelPopUpsOnMobileDevices(RightPanelConstant.AssociatedWorkkardsText)}><Icon name="associatedWorkkards" className="icon shift__top__1" /></li>
                        <li onClick={props.toggleChangeOwnerBlock}><Icon name="changeOwners" className="icon shift__top__1" /></li>
                    </ul>
                </div>
                {/* action menu for  middle panel like close  activity on the basis of permissions  */}

                <div className="detailHeader inProgressMob">
                                   

                    {activityDetail.activityId ?
                        <React.Fragment>
                            <div className="detailHeaderLeft" data-test={`activityTitle ${activityDetail.activityName}`}>
                                {
                                    (
                                        !isLeftPanelVisible || CommonUtil.mobileAndTabletcheck()
                                    )
                                        ?
                                        (
                                            <>
                                                <div ref={activityDetailRef} className={showActivityListDropDown ? "dropDown alignMiddle pd__none mr__1 active" : "dropDown alignMiddle pd__none mr__1"}>
                                                    <h1 onClick={() => setShowActivityListDropDown(prev => !prev)} className="mr rowFlex" title={activityDetail.activityName}><span className="activityTitle">{activityDetail.activityName}</span> <span className="h__16">
                                                        <Icon name="arrow" className="icon" /></span></h1>
                                                    <div className={showActivityListDropDown ? "dropDownMenu activityDropDown onClick" : "dropDownMenu activityDropDown openRight"} style={{ display: `${showActivityListDropDown ? 'block' : 'none'}` }}>
                                                        {renderActivityListing(activityListing)}
                                                    </div>
                                                </div>
                                            </>
                                        )
                                        :
                                        (
                                            <h1 className="mr" title={activityDetail.activityName}><span className="activityTitle">{activityDetail.activityName}</span></h1>
                                        )

                                }
                                <a href="javascript:void(0);" className="activityDetailText" onClick={() => { showActivityDetails() }}>{MiddlePanelConstant.DetailsText}</a>
                                {
                                    showDetailTooltip && <ActivityDetail canEdit={canEditActivity} canEditActivity={canEditActivity} title={DETAIL_INFO} onClose={closeDialogBox} data={activityDetail} />
                                }
                            </div>
                            <div className="detailHeaderRight">
                                {!sessionContext.isAuditUser && <>
                                    {canChangeProgress &&
                                        <div className="alignMiddle inProgressAction formGroup mrNone" data-test={`inProgress ${activityDetail.progress}`}>In Progress
                                            <Select
                                                options={inProgressOptions}
                                                selected={activityDetail.progress}
                                                onSelect={(value) => onProgressChange(value)}
                                                openOnClick={true}
                                                iconName="downArrow"
                                                styleClass="ml wth-5"
                                                widthClass="small"
                                                className="progressSelect"
                                                isOpenRight={true}
                                            />
                                        </div>
                                    }
                                    {
                                        isMobileDevice ?
                                            <>
                                                <div ref={menuActionRef} className={showMenuNoteAndDiary ? "dropDown active" : " dropDown"}>
                                                    <button className="btn btnAdd  addIcon ml buttonGradient" onClick={onClickMenushowMenuNoteAndDiaryButton}><Icon name="add" className="icon white" /></button>
                                                    <div className={showMenuNoteAndDiary ? "dropDownMenu openRight onClick" : "dropDownMenu openRight"} >
                                                        {canAddNote && isAddNoteVisible && isModuleEnabled(activityDetail.activityId ? "activities.activity_notes" : "workkards.add_note") && <span onClick={onCreateNoteClick} ><a href="javascript:void(0);"><span>{'Add  ' + MiddlePanelConstant.AddNoteButtonText}</span></a></span>}
                                                        {isModuleEnabled("diaries") && <span onClick={onAddDiaryClick} ><a href="javascript:void(0);"><span>{'Add  ' + MiddlePanelConstant.CreateDiaryText}</span></a></span>}
                                                    </div>
                                                </div>
                                            </>
                                            : 
                                            <>
                                                {
                                                    canAddNote && isAddNoteVisible && isModuleEnabled(activityDetail.activityId ? "activities.activity_notes" : "workkards.add_note") && 
                                                    <button
                                                        type="button"
                                                        className="btn ripple btnSqure buttonGradient mr__1 addIcon addNoteButton mr__r__0" 
                                                        title="Add note" 
                                                        data-test="addNote" 
                                                        onClick={onCreateNoteClick}
                                                    >
                                                        <Icon name="add" className="icon white" /> 
                                                        <span className="ml"> {MiddlePanelConstant.AddNoteButtonText}</span>
                                                    </button>
                                                }
                                                {isModuleEnabled("diaries") && <button 
                                                    type="button" 
                                                    data-test="addDiary" 
                                                    onClick={onAddDiaryClick} 
                                                    title="Add diary" 
                                                    className="btn ripple btnSqure buttonGradient mr__1 addIcon addNoteButton"
                                                >
                                                    <Icon name="add" className="icon white" /> 
                                                    <span className="ml">{MiddlePanelConstant.CreateDiaryText}</span>
                                                </button>
                                                }
                                            </>                                                
                                    }
                                    {((getActivityMenuList() || []).filter(Boolean).length > 0 || (IS_PARTIES_ENABLED == "true" && isModuleEnabled("parties"))) &&
                                    <div ref={menuActionRef} className={showMenuAction ? "dropDown h__24 ml active" : " dropDown h__24 ml"}>
                                        <span className="icon" onClick={onClickMenuActionButton}><Icon name="more" className="icon more" /></span>
                                        <div className={showMenuAction ? "dropDownMenu openRight onClick" : "dropDownMenu openRight"} >
                                            {getActivityMenuList()}
                                            {IS_PARTIES_ENABLED == "true" && isModuleEnabled("parties") && <a href="javascript:void(0)" id="associatePartyActivity" onClick={onAddPartyClick}>{MiddlePanelConstant.AddPartyText}</a>}
                                        </div>
                                    </div>
                                    }
                                </>
                                }
                            </div>
                        </React.Fragment>
                        : <>{ isMobileDevice && 
                            
                            <a className="addActivitiesToMobile alignMiddle">
                                <h2 className="black">Activities (0)</h2>
                                { !sessionContext.isAuditUser && isModuleEnabled("workkards.add_activity") && isModuleEnabled("activities.create_activity") && <button className="btn btnAdd buttonGradient addIcon ml" onClick={onCreateActivityClick} title="Add activity"><Icon name="add" className="icon" /></button>}
                            </a>
                        }
                        </>
                    }
                </div>
                {/* tab  bar on click  tab switch  the tab  */}
                <div className="tabNav">
                    <div className="tabs">
                        <a href="javascript:void(0)" onClick={() => onTabClick(0)} className={activeTab === 0 ? "noteIcon active" : 'noteIcon'}><Icon name="note" className="icon" /> <span>Notes ({returnCount('notes')})</span></a>
                        {isModuleEnabled(activityDetail.activityId ? "activities.files" : "workkards.files") && <a href="javascript:void(0)" onClick={() => onTabClick(1)} className={activeTab === 1 ? "attachIcon active " : 'attachIcon'}><Icon name="attach" className="icon" /> <span>Files ({returnCount('files')})</span></a>}
                        {isModuleEnabled("diaries") && <a href="javascript:void(0)" onClick={() => onTabClick(2)} className={activeTab === 2 ? "diaryIcon active" : 'diaryIcon'}><Icon name="diaries" className="icon" /> <span>Diaries ({returnCount('diaries')})</span></a>}
                        {isModuleEnabled(activityDetail.activityId ? "activities.logs" : "workkards.logs") && <a href="javascript:void(0)" onClick={() => onTabClick(3)} className={activeTab === 3 ? "logIcon active" : 'logIcon'}><Icon name="logs" className="icon" /> <span>Logs ({returnCount('logs')})</span></a>}
                        {IS_PARTIES_ENABLED == "true" && isModuleEnabled("parties") && <a href="javascript:void(0)" onClick={() => onTabClick(4)} className={activeTab === 4 ? "associatedPartIcon active" : 'associatedPartIcon'}><Icon name="associatedParty" className="icon" /> <span>Parties ({returnCount('parties')})</span></a>}
                    </div>
                </div>
                {/** render  clicked  tab  and  update redux state */}
                {renderTabs()}
            </div>
        );
    };

    return (
        <div className="secondLayout" style={showFilter?{display:'none'}:null}>
            <RightPopUpComponent />

            {
                (workkard.Id && workkard.Id != 0 && sessionContext && userView) && renderView(toggleView)
            }
        </div>
    );
};

export default MiddlePanelContainer;
